import { DatasourcedWidgetMetadata } from '@/modules/ta/widget/models/metadata/DataSourcedWidgetMetadata';

export class ExecutiveSummaryWidgetMetadata extends DatasourcedWidgetMetadata {
  constructor(model = {}) {
    super(model);
  }
}
